function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWhistleIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    style: {
      fill: "#ce78ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.93,17.46C21.6,17.46,7.6,32.53,8.09,50.93c.44,17,13.86,31.6,30,31.61,16.85,0,30.59-7.27,30.59-39.34l25.44-4V17.46Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.01,
    cy: 51.01,
    rx: 9.75,
    ry: 10.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhistleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whistle_icon.e1870427.svg";
export { ForwardRef as ReactComponent };